import { render, staticRenderFns } from "./validacion_presentacion.vue?vue&type=template&id=219495f1"
import script from "./validacion_presentacion.js?vue&type=script&lang=js&external"
export * from "./validacion_presentacion.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports